const locale = {
  service: {
    name: "Service",
    list: {
      badge: "Service",
    },
    tabs: {
      product: "Product",
      service: "Service",
    },
    breadcrumb: {
      createPath: "Create service",
      editPath: "Edit service",
      editProfessionals: "Professionals",
    },
    form: {
      nameLabel: "Service name",
      nameError: "Service name is required",
    },
    detail: {
      title: "Detail",
    },
    information: {
      title: "Service information",
    },
    config: {
      title: "Service configuration",
    },
    mapContent: {
      detailLabel: "Detail",
      informationLabel: "Information",
      configLabel: "Configuration",
    },
    duration: {
      title: "Service duration",
      customLabel: "Custom duration",
      scheduleInfo:
        "Your store business hours are managed from the Domun mobile app.",
      scheduleCardText:
        "Set your store business hours so customers can book your services.",
      configureSchedule: "Configure business hours",
      editSchedule: "Edit store business hours",
      options: {
        one: "1 Hr.",
        two: "2 Hr.",
        three: "3 Hr.",
        other: "Custom",
        none: "",
      },
    },
    professionals: {
      title: "Professionals",
      add: "Add",
      edit: "Edit",
      empty: "You have not added professionals to this service yet.",
      editorTitle: "Service professionals",
      editorDescription: "Add the professionals who can perform this service.",
      namePlaceholder: "Professional name",
      enabled: "Active",
      remove: "Remove",
      addRow: "Add professional",
    },
  },
  product: {
    name: "Product",
    breadcrumb: {
      createPath: "Create product",
      editPath: "Edit product",
      editPhotos: "Edit photos",
      editFeatures: "Edit features",
      editStock: "Edit stock"
    },
    mapContent: {
      detailLabel: "Detail",
      inventoryLabel: "Inventory",
      productInfoLabel: "Product information",
    },
    productDetail: {
      title: "Detail"
    },
    uploadImage: {
      principalTag: "Principal",
    },
    photoAi: {
      cta: "Photo AI",
      referenceTitle: "Choose a reference photo",
      referenceConfirm: "Continue",
      resultsTitle: "Suggested images",
      resultsDescription: "Select the images you want to add to the product.",
      add: "Add",
      adding: "Adding...",
      loading: "Looking for similar images...",
      cancel: "Cancel",
      acquireTitle: "Activate Photo AI",
      acquireDescription:
        "Find similar images and improve your product photos.",
      acquireCta: "Get add-on",
      error: "Could not fetch similar images",
      noSlots: "You reached the photo limit for this product",
      addSuccess: "Images added",
      addError: "Could not add the images",
    },
    editImage: {
      title: "Edit photos",
      description: "Drag and drop photos to change the order"
    },
    productInventory: {
      title: "Inventory"
    },
    productInformation: {
      title: "Product information"
    },
    productFeatures: {
      stock: {
        title: "Stock"
      },
      featureForm: {
        title: "Features",
        featureNameLabel: "Feature",
        optionsLabel: "Options",
        addLink: "Add other feature"
      }
    }
  },
};

export default locale;
